import React, { Children } from "react";

import { Navigate } from "react-router-dom";

export const PrivateRoutes = ({ children }) => {
  let aimsToken = localStorage.getItem("aimsToken");
 

  if (!aimsToken) {
    return <Navigate to="/log-in"  />;
  }
  return <>{children}</>;
};
